"use strict";
var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
Object.defineProperty(exports, "__esModule", { value: true });
exports.RentalPriceTypes = void 0;
var RoomCount_1 = require("./RoomCount");
exports.RentalPriceTypes = {
    hy: {
        rent: {
            WITH_PROPERTY_TYPE: {
                apartment: 'oravardzov-bnakaran-',
                house: 'oravardzov-arandznatun-',
            },
            WITH_PROPERTY_STRUCTURE_TYPE: {
                apartment: 'oravardzov-norakaruic-bnakaran-',
                house: 'oravardzov-norakaruic-arandznatun-',
            },
            WITH_ROOM_PROPERTY_STRUCTURE_TYPE: {
                apartment: (_a = {},
                    _a[RoomCount_1.ROOM_COUNT.ONE] = 'oravardzov-1-senyakanoc-norakaruic-bnakaran-',
                    _a[RoomCount_1.ROOM_COUNT.TWO] = 'oravardzov-2-senyakanoc-norakaruic-bnakaran-',
                    _a[RoomCount_1.ROOM_COUNT.TREE] = 'oravardzov-3-senyakanoc-norakaruic-bnakaran-',
                    _a[RoomCount_1.ROOM_COUNT.FOUR] = 'oravardzov-4-senyakanoc-norakaruic-bnakaran-',
                    _a),
                house: (_b = {},
                    _b[RoomCount_1.ROOM_COUNT.ONE] = 'oravardzov-1-senyakanoc-norakaruic-arandznatun-',
                    _b[RoomCount_1.ROOM_COUNT.TWO] = 'oravardzov-2-senyakanoc-norakaruic-arandznatun-',
                    _b[RoomCount_1.ROOM_COUNT.TREE] = 'oravardzov-3-senyakanoc-norakaruic-arandznatun-',
                    _b[RoomCount_1.ROOM_COUNT.FOUR] = 'oravardzov-4-senyakanoc-norakaruic-arandznatun-',
                    _b),
            },
            WITH_ROOM_PROPERTY_TYPE: {
                apartment: (_c = {},
                    _c[RoomCount_1.ROOM_COUNT.ONE] = 'oravardzov-1-senyakanoc-bnakaran-',
                    _c[RoomCount_1.ROOM_COUNT.TWO] = 'oravardzov-2-senyakanoc-bnakaran-',
                    _c[RoomCount_1.ROOM_COUNT.TREE] = 'oravardzov-3-senyakanoc-bnakaran-',
                    _c[RoomCount_1.ROOM_COUNT.FOUR] = 'oravardzov-4-senyakanoc-bnakaran-',
                    _c),
                house: (_d = {},
                    _d[RoomCount_1.ROOM_COUNT.ONE] = 'oravardzov-1-senyakanoc-arandznatun-',
                    _d[RoomCount_1.ROOM_COUNT.TWO] = 'oravardzov-2-senyakanoc-arandznatun-',
                    _d[RoomCount_1.ROOM_COUNT.TREE] = 'oravardzov-3-senyakanoc-arandznatun-',
                    _d[RoomCount_1.ROOM_COUNT.FOUR] = 'oravardzov-4-senyakanoc-arandznatun-',
                    _d),
            },
        },
    },
    ru: {
        rent: {
            WITH_PROPERTY_TYPE: {
                apartment: 'posutochno-kvartira-',
                house: 'posutochno-chastniy-dom-',
            },
            WITH_PROPERTY_STRUCTURE_TYPE: {
                apartment: 'posutochno-kvartiri-v-novostroikax-',
                house: 'posutochno-chastnie-doma-novostroiki-',
            },
            WITH_ROOM_PROPERTY_STRUCTURE_TYPE: {
                apartment: (_e = {},
                    _e[RoomCount_1.ROOM_COUNT.ONE] = 'posutochno-1-komnatnaya-kvartira-v-novostroike-',
                    _e[RoomCount_1.ROOM_COUNT.TWO] = 'posutochno-2-komnatnaya-kvartira-v-novostroike-',
                    _e[RoomCount_1.ROOM_COUNT.TREE] = 'posutochno-3-komnatnaya-kvartira-v-novostroike-',
                    _e[RoomCount_1.ROOM_COUNT.FOUR] = 'posutochno-4-komnatnaya-kvartira-v-novostroike-',
                    _e),
                house: (_f = {},
                    _f[RoomCount_1.ROOM_COUNT.ONE] = 'posutochno-1-komnatniy-chastniy-dom-novostroika-',
                    _f[RoomCount_1.ROOM_COUNT.TWO] = 'posutochno-2-komnatniy-chastniy-dom-novostroika-',
                    _f[RoomCount_1.ROOM_COUNT.TREE] = 'posutochno-3-komnatniy-chastniy-dom-novostroika-',
                    _f[RoomCount_1.ROOM_COUNT.FOUR] = 'posutochno-4-komnatniy-chastniy-dom-novostroika-',
                    _f),
            },
            WITH_ROOM_PROPERTY_TYPE: {
                apartment: (_g = {},
                    _g[RoomCount_1.ROOM_COUNT.ONE] = 'posutochno-1-komnatnaya-kvartira-',
                    _g[RoomCount_1.ROOM_COUNT.TWO] = 'posutochno-2-komnatnaya-kvartira-',
                    _g[RoomCount_1.ROOM_COUNT.TREE] = 'posutochno-3-komnatnaya-kvartira-',
                    _g[RoomCount_1.ROOM_COUNT.FOUR] = 'posutochno-4-komnatnaya-kvartira-',
                    _g),
                house: (_h = {},
                    _h[RoomCount_1.ROOM_COUNT.ONE] = 'posutochno-1-komnatniy-chastniy-dom-',
                    _h[RoomCount_1.ROOM_COUNT.TWO] = 'posutochno-2-komnatniy-chastniy-dom-',
                    _h[RoomCount_1.ROOM_COUNT.TREE] = 'posutochno-3-komnatniy-chastniy-dom-',
                    _h[RoomCount_1.ROOM_COUNT.FOUR] = 'posutochno-4-komnatniy-chastniy-dom-',
                    _h),
            },
        },
    },
    en: {
        rent: {
            WITH_PROPERTY_TYPE: {
                apartment: 'daily-rent-apartments-',
                house: 'daily-rent-house-',
            },
            WITH_PROPERTY_STRUCTURE_TYPE: {
                apartment: 'daily-rent-new-apartment-',
                house: 'daily-rent-new-house-',
            },
            WITH_ROOM_PROPERTY_STRUCTURE_TYPE: {
                apartment: (_j = {},
                    _j[RoomCount_1.ROOM_COUNT.ONE] = 'daily-rent-1-room-new-apartment-',
                    _j[RoomCount_1.ROOM_COUNT.TWO] = 'daily-rent-2-room-new-apartment-',
                    _j[RoomCount_1.ROOM_COUNT.TREE] = 'daily-rent-3-room-new-apartment-',
                    _j[RoomCount_1.ROOM_COUNT.FOUR] = 'daily-rent-4-room-new-apartment-',
                    _j),
                house: (_k = {},
                    _k[RoomCount_1.ROOM_COUNT.ONE] = 'daily-rent-1-room-new-house-',
                    _k[RoomCount_1.ROOM_COUNT.TWO] = 'daily-rent-2-room-new-house-',
                    _k[RoomCount_1.ROOM_COUNT.TREE] = 'daily-rent-3-room-new-house-',
                    _k[RoomCount_1.ROOM_COUNT.FOUR] = 'daily-rent-4-room-new-house-',
                    _k),
            },
            WITH_ROOM_PROPERTY_TYPE: {
                apartment: (_l = {},
                    _l[RoomCount_1.ROOM_COUNT.ONE] = 'daily-rent-1-room-apartment-',
                    _l[RoomCount_1.ROOM_COUNT.TWO] = 'daily-rent-2-room-apartment-',
                    _l[RoomCount_1.ROOM_COUNT.TREE] = 'daily-rent-3-room-apartment-',
                    _l[RoomCount_1.ROOM_COUNT.FOUR] = 'daily-rent-4-room-apartment-',
                    _l),
                house: (_m = {},
                    _m[RoomCount_1.ROOM_COUNT.ONE] = 'daily-rent-1-room-house-',
                    _m[RoomCount_1.ROOM_COUNT.TWO] = 'daily-rent-2-room-house-',
                    _m[RoomCount_1.ROOM_COUNT.TREE] = 'daily-rent-3-room-house-',
                    _m[RoomCount_1.ROOM_COUNT.FOUR] = 'daily-rent-4-room-house-',
                    _m),
            },
        },
    },
};
